import { RequestResponse } from '../../../../../core/application/http-response/http-response';
import { CacheStorage } from '../../../../../core/application/protocols/cache-storage';
import {
  HttpClient,
  HttpMethod
} from '../../../../../core/application/protocols/http-client';
import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { error, success } from '../../../../../core/domain/either/either';
import { GoogleLoginForm } from '../../domain/models/google-models';
import { GoogleLoginResponse } from '../../domain/models/google-response';

export class GoogleLogin implements ServiceCommand<GoogleLogin.Response> {
  constructor(
    private readonly httpClient: HttpClient<GoogleLogin.Response>,
    private readonly cacheStorage: CacheStorage,
    private readonly tokenKey: string,
    private readonly url: string
  ) {}

  async execute(
    params: GoogleLogin.Params
  ): Promise<ServiceCommand.Response<GoogleLogin.Response>> {
    const httpResponse = await this.httpClient.request({
      method: HttpMethod.POST,
      url: this.url,
      body: params,
      queryParams: { client: 'google' }
    });

    const responseOrError = RequestResponse.handle(httpResponse);

    if (responseOrError.isError()) {
      return error(responseOrError.value);
    }
    const response = responseOrError.value.response;

    const { accessToken } = response;
    this.cacheStorage.set(this.tokenKey, accessToken);

    return success(response);
  }
}

export namespace GoogleLogin {
  export type Params = GoogleLoginForm;

  export type Response = GoogleLoginResponse;
}
